export default __webpack_public_path__ + "static/media/VideoAnalyticsNavIcon.0b07950f.svg";